<template>
   <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Kurir {{this.$route.params.ref}}</h3>
        <div class="ml-auto">
          <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
           Batal
          </vs-button>
        </div> 
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
            <b>Terdapat Kesalahan..</b>
            <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </vs-alert>
        <h5 class="card-title mb-0">Pilih Kantor</h5>
                <JqxDropDownButton ref="myDropDownButton" :width="150" :height="25">
                    <JqxGrid ref="myGrid" @rowselect="myGridOnRowSelect($event)" :ready="ready"
                            :width="width" :source="dataAdapter" :columns="columns"
                            :pageable="true" :columnsresize="true" :autoheight="true" :autorowheight="true" 
                            :sortable="true" :filterable="true" :showfilterrow="true" :pagesize="5"
                    >
                    </JqxGrid>
                </JqxDropDownButton>
        <div>
          <vs-row>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="3">  
                <vs-input label="User ID" class="w-100 mt-4" ref="transval" v-model="formdata.email" /> 
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="3">  
                <vs-input label="NAMA" class="w-100 mt-4" ref="transval" v-model="formdata.name" /> 
            </vs-col>  
          </vs-row>
          <vs-row>
              <vs-col vs-lg="5" vs-xs="12" vs-sm="3">  
                  <vs-input label="PASSWORD" class="w-100 mt-4" ref="transval" v-model="formdata.password" />
              </vs-col>
              <vs-col vs-lg="5" vs-xs="12" vs-sm="3">  
                  <vs-input label="ONGKOS PER RESI" class="w-100 mt-4" ref="transval" v-model="formdata.ongkos_resi" />
              </vs-col>
              
          </vs-row>
        </div>
        <div class="btn-alignment mt-4">
          <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
          <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
        </div>
      </vs-card>
    </vs-col>
    
   </vs-row>
</template>

<script>
  /* eslint-disable no-console */
  /* eslint-disable no-case-declarations */
  import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
  import JqxDropDownButton from "jqwidgets-scripts/jqwidgets-vue/vue_jqxdropdownbutton.vue";
  

  export default {
    components: {
        JqxGrid,
        JqxDropDownButton,
    },  
    data: function () {
      return {
        // eslint-disable-next-line
        dataAdapter: new jqx.dataAdapter(this.source, {
            formatData: function (data) {
                return  JSON.stringify(data);
            },
            beforeSend: function (jqxhr, settings) { 
                settings.xhrFields = {
                    withCredentials: true
                },
                jqxhr.setRequestHeader("X-XSRF-TOKEN",window.$cookies.get('XSRF-TOKEN'))
            }
        }),
        width: "750",
        columns: [
            { text: 'Jenis', filtertype: 'list', filteritems: this.items, datafield: 'jenis', width: '100', },
            { text: 'Kode', datafield: 'kode', width: '100' },
            { text: 'Nama', datafield: 'nama', width: '200' },
            { text: 'Alamat', datafield: 'alamat', width: '350' },
        ],
        formdata: {
            email:'',
            name:'',
            role_id:'0',
            office_id:'',
            kurir:'1',
            password:'',
            ongkos_resi:'0',
            isEdit: false,
            prevReferensi:''
        },
        optrole:[],
        errors:[],
        idtrans:0,
        inputUrl: '/api/userapp'
      }
    },
    beforeCreate: function () {
      this.source = {
        datafields: [
          { name: 'id', type: 'number'},
          { name: 'jenis', type: 'string'},
          { name: 'kode', type: 'string'},
          { name: 'nama', type: 'string'},
          { name: 'alamat', type: 'string'},
        ],
        datatype: 'json',
        id: 'kode',
        url: this.$urlbackend+'/api/office',
        type: 'get',
        deleterow: function (rowid, commit) {
            commit(true);
        },
      }
      this.editrow = -1;
    },
    methods:{
         ready: function() {
            this.$refs.myGrid.selectrow(0);
            this.$refs.myGrid.focus();
        },
        backpage: function(){
            this.$router.go(-1);
        },
        myGridOnRowSelect: function (event) {
            this.formdata.datatrans = [];
            let args = event.args;
            let row = this.$refs.myGrid.getrowdata(args.rowindex);
            this.formdata.office_id = row['id']
            let dropDownContent = '<div style="position: relative; margin-left: 3px; margin-top: 5px;">' + row['kode'] + '</div>';
            this.$refs.myDropDownButton.setContent(dropDownContent);
           
            
        },
        getAllData: function(){
            //edit mode init data
            this.$http.get('/api/role').then(response => {
                //console.log(response.data);
                this.optrole = response.data
            }).catch(error=>{
                //console.log(error);
            });
            if(this.$route.params.ref != null){
                this.formdata.isEdit = true
                this.$http.get(this.inputUrl+"/"+this.$route.params.ref).then(response => {
                    console.log(response.data)
                    //this.formdata.datatrans = response.data;
                    const keys = Object.keys(response.data)
                    console.log(keys)
                    var self = this
                    for(const key of keys){
                        //console.log(key)
                        if (this.formdata.hasOwnProperty(key))
                            this.formdata[key] = response.data[key]
                        if(key == 'id'){
                            this.formdata.prevReferensi = response.data[key]
                        }
                            
                    }
                }).catch(error=>{
                    console.log(error)
                    this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
                });
            }
            //edit mode init data

            this.formdata.pemohon_id = this.$store.getters.getUserId
        },
        checkForm:function(e) {
            this.errors = [];
            //cek dari client dulu...
            
            if(this.formdata.email == ''){
                this.errors.push("User ID belum terisi...")
            }

            if(this.formdata.name == ''){
                this.errors.push("Nama belum terisi...")
            }

            

            if(this.formdata.password == '' && !this.formdata.isEdit){
                this.errors.push("Password belum terisi...")
            }

            if(this.errors.length > 0){
                this.handleError(this.error,'local')
            }
            else{
                this.$vs.loading({'type':'radius'})
                this.$http.post(this.inputUrl,{
                    formdata : this.formdata
                }).then(response => {
                    console.log(response);
                    this.handleSuccess();
                    //
                }).catch(error=>{
                    console.log(error.response)
                    this.handleError(error)
                })
            }
        },
        handleError: function(error,type=''){
            if(type != 'local'){
                if (error.response != null){
                    let status = error.response.status
                    console.log(status)
                    switch(status){
                        case 422 :
                            const keys = Object.keys(error.response.data.errors)
                            //console.log(keys);
                            for(const key of keys){
                                //console.log(key)
                                //console.log(error.response.data.errors[key][0])
                                this.errors.push(error.response.data.errors[key][0])
                            }
                        break
                        case 500 :
                            this.errors.push('Internal server error.. silahkan hubungi administrator')
                            break
                        default:
                            this.errors.push('Terjadi error di server..')
                            break
                    }
                }
                else
                    this.errors.push('Terjadi error di server..')
            }
            console.log('handle error')
            this.notify()
            this.$vs.loading.close()
        },
        handleSuccess: function(){
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
            //this.$router.push('/jurnal/ju');
            this.$router.push({name : 'kurirlist'});
        },
        notify: function(){
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:()=>{
                    window.scrollTo(0,0);
                },
            })
        }
    },
    watch:{
        'formdata.module_id': function(){
            let mod_id = this.formdata.module_id
            if(mod_id != 1)
                this.formdata.jenis = 0
            let mod_name = this.optmodule.filter(item => item.id == mod_id).map(item => item.controller).join('');
            this.formdata.mod_name = mod_name
        },
    },
    mounted: function () {
        this.getAllData();
    },
  }
</script>
<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>